// extracted by mini-css-extract-plugin
module.exports = {"root":"Status_root__PF590","approved":"Status_approved__1OlWA","rejected":"Status_rejected__3yu7b","expired":"Status_expired__1d_xN","label":"Status_label__3poq-"};